import type { PersonInvolvement } from "../types/involvement.js";
import { isInvolvementLive } from "./isInvolvementLive.js";

/**
 * Whether the person is unallocated, with no live responsible user: the one
 * moment `allocate_responsible_user` exists for. A responsible user whose
 * involvement has ended leaves the person to be allocated again.
 *
 * A responsible user holds the involvement until replaced, so is never given
 * an expiry: a live responsible user and an unended one are the same, as the
 * one-live-responsible-user index assumes.
 */
export const isPersonUnallocated = (
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "endedAt" | "expiresAt"
  >[],
  now: Date = new Date(),
): boolean =>
  !involvements.some(
    (involvement) =>
      involvement.kind === "responsible_user" &&
      isInvolvementLive(involvement, now),
  );
